import React, { useEffect, useRef, useState } from "react";

export function Dropdown({ label = "Actions", children }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    function onDoc(e) {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);
  return (
    <div className="relative" ref={ref}>
      <button className="px-2 py-1 border rounded text-sm" onClick={() => setOpen((v) => !v)}>{label}</button>
      {open && (
        <div className="absolute right-0 mt-1 w-44 bg-white border rounded shadow z-20">
          {children}
        </div>
      )}
    </div>
  );
}

export function DropdownItem({ children, onClick, danger }) {
  return (
    <button
      className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 ${danger ? 'text-red-600' : 'text-gray-800'}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

